
import { useStore } from "vuex";
import { computed, ref } from "vue";
import _ from "lodash";
import { Form, Field, ErrorMessage, FormActions } from "vee-validate";
import { IncidentDTO } from "@moderrotech/servers-communication-library/src/types";

export default {
  components: { Form, Field, ErrorMessage },
  setup() {
    const store = useStore();

    const customerInfo = computed(() => store.state.metadata.customerInfo);
    const incident = computed((): IncidentDTO => store.state.incident.incident);

    const isDisabled = ref(false);

    return {
      customerInfo,
      isDisabled,
      handleSubmit: (
        values: { [k: string]: string },
        actions: FormActions<any>
      ) => {
        isDisabled.value = true;

        store.dispatch("tickets/create", {
          incidentUuid: incident.value.id,
          payload: _.pickBy(values, v => !!v),
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      },
      handleCancelClick: () => {
        isDisabled.value = true;

        store.dispatch("incident/close", {
          callback: () => (isDisabled.value = false),
          errorCallback: () => (isDisabled.value = false)
        });
      },
      ..._.pick(_, "pick")
    };
  }
};
